var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "donut_small_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AllocationIcon; Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    d: "M15.99 9H19.42C18.6 7 17 5.4 15 4.58V8.01C15.37 8.29 15.71 8.63 15.99 9Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "AllocationIcon; Light Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    opacity: 0.5,
    d: "M4 12C4 15.35 6.04 18.24 9 19.42V15.98C7.77 15.05 7 13.58 7 11.99C7 10.4 7.77 8.93 9 8V4.58C6.04 5.76 4 8.65 4 12Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "AllocationIcon; Light Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    opacity: 0.5,
    d: "M15 15.99V19.42C17 18.6 18.6 17 19.42 15H15.99C15.71 15.37 15.37 15.71 15 15.99Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "AllocationIcon; Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.95 11H14.82C14.51 10.15 13.85 9.49 13 9.18V2.05C17.72 2.52 21.48 6.28 21.95 11ZM19.42 9C18.6 7 17 5.4 15 4.58V8.01C15.37 8.29 15.71 8.63 15.99 9H19.42Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "AllocationIcon; Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21.95C5.95 21.45 2 17.19 2 12C2 6.81 5.95 2.55 11 2.05V9.18C9.84 9.6 9 10.7 9 12C9 13.3 9.84 14.4 11 14.82V21.95ZM9 8.02V4.58C6.04 5.76 4 8.65 4 12C4 15.35 6.04 18.24 9 19.43V15.99C7.77 15.06 7 13.59 7 12C7 10.41 7.77 8.94 9 8.02Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "AllocationIcon; Dark Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21.95V14.82C13.85 14.51 14.51 13.85 14.82 13H21.95C21.48 17.72 17.72 21.48 13 21.95ZM15.99 15C15.71 15.38 15.37 15.71 15 15.99V19.42C17 18.6 18.6 17 19.42 15H15.99Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocationIcon);
export default __webpack_public_path__ + "static/media/allocationIcon.db0fd0df29ac79fcbff914a524ab7671.svg";
export { ForwardRef as ReactComponent };